import { Questions } from "../types/questions";
import { ATLAS, ATLASCROSSPORT, ID4, TAOS, TIGUAN } from "./models";

const questions : Questions = {
    personality : [
        {
            key : 'upFoAnything',
            models: [TAOS]
        },
        {
            key : 'dressedToImpress',
            models: [TIGUAN]
        },
        {
            key : 'liveForTheRush',
            models: [ID4, TIGUAN]
        },
        {
            key : 'makeAStatement',
            models: [ATLASCROSSPORT]
        },
        {
            key: 'moreMerrier',
            models: [ATLAS]
        }
    ],
    
    priority : [
        {
            key : 'drivingToBeFun',
            models : [TAOS, ID4]
        },
        {
            key : 'impressesNeighbours',
            models : [TIGUAN, ATLASCROSSPORT]
        },
        {
            key : 'acceleration',
            models: [ID4]
        },
        {
            key : 'lessTime',
            models : [TAOS, ID4]
        },
        {
            key : 'roomForKids',
            models : [ATLAS, ATLASCROSSPORT]
        },
        {
            key : 'perfectCityDogParks',
            models : [TAOS, TIGUAN]
        }
    ],

    typical : [
        {
            key: 'dailyCommute',
            models: [ID4, TAOS ]
        },
        {
            key: 'outdoorAdventures',
            models: [ATLAS, ATLASCROSSPORT, TAOS]
        },
        {
            key: 'roadTrips',
            models: [ATLAS, TIGUAN]
        },
        {
            key: 'weeklyFamilyOuting',
            models: [ID4, TAOS, TIGUAN]
        }
    ],

    seating : [
        {
            key : 'meAndOther',
            models: [TAOS, ID4]
        },
        {
            key : 'wholeFamily',
            models: [TIGUAN, ID4, ATLASCROSSPORT, TAOS]
        },
        {
            key : 'asManyCanFit',
            models: [ATLAS]
        }
    ],

    iceEv : [
        {
            key : 'gasPowered',
            models : [TAOS, TIGUAN, ATLAS, ATLASCROSSPORT]
        },
        {
            key : 'electricReady',
            models : [ID4]
        },
        {
            key : 'openToEither',
            models : [ATLAS, ATLASCROSSPORT, ID4, TAOS, TIGUAN]
        }
    ],

    budget : [
        {
            key : 'price35000',
            models : [TAOS]
        },
        {
            key : 'price50000',
            models: [TIGUAN]
        },
        {
            key : 'price50000plus',
            models : [ATLAS, ATLASCROSSPORT, ID4]
        }
    ]
};

export default questions;